import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Label } from '../../../Typography/index.js';
import { IconContainer, IconLogo } from '../../../Icon/index.js';
const LogoBar = () => (_jsxs("section", { "data-cy": "footer-logo", css: css({
        width: 'calc(100% / 3)',
        textAlign: 'center',
        '@media screen and (max-width: 768px)': {
            gridArea: 'logo',
            width: '100%',
            margin: '0 auto 20px'
        }
    }), children: [_jsx(IconContainer, { ariaLabel: "logo", style: { width: 106, height: 20 }, children: _jsx(IconLogo.Logo, {}) }), _jsx(Label, { size: "small", element: "span", style: {
                letterSpacing: 2.2,
                display: 'flex',
                justifyContent: 'center',
                padding: '10px 0 0 0',
                fontWeight: 600,
                '@media (min-width: 768px)': {
                    display: 'none'
                }
            }, children: "Hire different" })] }));
export default LogoBar;
//# sourceMappingURL=index.js.map